<template>
  <div class="list-container">
    <div v-show="!dialogFormVisible && !addPriceVisible">
      <div class="filter-container">
        <div class="filter-box">
          <span class="label">物料编号</span>
          <el-input
            v-model="listQuery.materialNo"
            style="width: 200px"
            :size="t('table.btnSize')"
            class="filter-item"
            clearable
            @keyup.enter="handleFilter"
          />
        </div>
        <div class="filter-box">
          <span class="label">物料品牌</span>
          <el-input
            v-model="listQuery.materialBrand"
            style="width: 200px"
            :size="t('table.btnSize')"
            class="filter-item"
            clearable
            @keyup.enter="handleFilter"
          />
        </div>
        <div class="filter-box">
          <span class="label">物料名称</span>
          <el-input
            v-model="listQuery.materialName"
            style="width: 200px"
            :size="t('table.btnSize')"
            class="filter-item"
            clearable
            @keyup.enter="handleFilter"
          />
        </div>
        <div class="filter-box">
          <span class="label">物料型号</span>
          <el-input
            v-model="listQuery.materialModel"
            style="width: 200px"
            :size="t('table.btnSize')"
            class="filter-item"
            clearable
            @keyup.enter="handleFilter"
          />
        </div>
        <div class="filter-box">
          <span class="label">物料代码</span>
          <el-input
            v-model="listQuery.materialCode"
            style="width: 200px"
            :size="t('table.btnSize')"
            class="filter-item"
            clearable
            @keyup.enter="handleFilter"
          />
        </div>
        <div class="filter-box">
          <span class="label">位置名称</span>
          <el-input
            v-model="listQuery.location"
            style="width: 200px"
            :size="t('table.btnSize')"
            class="filter-item"
            clearable
            @keyup.enter="handleFilter"
          />
        </div>
        <div class="filter-box">
          <span class="label">创建人</span>
          <el-select :filterable="true" v-model="listQuery.createUser" class="filter-item" placeholder="" clearable @focus="getUserOptionRemote('')">
          <el-option
            v-for="item in userOption"
            :key="item.id"
            :label="item.mark"
            :value="item.id"
          />
        </el-select>
        </div>
        <div class="filter-box">
          <el-button
            v-waves
            class="filter-item "
            type="primary"
            :size="t('table.btnSize')"
            @click="handleFilter"
          >
            {{ t("table.search") }}
          </el-button>
          <!-- <el-button
            v-permission="{pkey:`${permissionName}_CONFIRM`}"
            class="filter-item"
            type="primary"
            :size="t('table.btnSize')"
            @click="handleCommand('batch-comfirm')"
          >
            批量出库确认
          </el-button> -->
          <el-button
            v-waves
            class="filter-item"
            :size="t('table.btnSize')"
            @click="handleReset"
          >
            {{ t("table.reset") }}
          </el-button>
          <span class="svg-icon cursor mr-10 ml-10" @click="handleCommand('refresh')" >
            <i class="icon-tubiao-27 iconfont"/>
          </span>
          <span class="svg-icon cursor" @click="handleCommand('column')">
            <i class="icon-tubiao-28 iconfont"/>
          </span>
          <span class="ml-10 filter-mark">红色代表状态为“待确认”物料</span>
        </div>
      </div>
      <grid-layout
        v-model:layout="layouts"
        :col-num="12"
        :row-height="rowHeight"
        :is-draggable="false"
        :is-resizable="true"
        :is-mirrored="false"
        :vertical-compact="true"
        :margin="[10, 10]"
        :use-css-transforms="false"
      >
        <grid-item
          v-for="(item, index) in layouts"
          :x="item.x"
          :y="item.y"
          :w="item.w"
          :h="item.h"
          :i="item.i"
          :key="item.i"
          :minW="item.minW"
          :maxW="item.maxW"
          :minH="item.minH"
          :static="item.static"
          @resize="handleResizedEvent"
          @resized="handleResizedEvent">
          <template v-if="index === 0">
            <TableList
              :ref="rf => { if (rf) tableDataRef[index] = rf }"
              v-loading="listLoading"
              :dataList="list"
              :columnAllData="columnAllData"
              :tableName="TableName"
              :permissionName="permissionName"
              :showSelection="false"
              :isShowPagination="false"
              :handleDefaultWidth="120"
              :highlightCurrentRow="true"
              :layoutHeight="true"
              :newHpx="newHpx"
              :canRefresh="false"
              :canChangeColumn="false"
              style="height:calc(100% );overflow:hidden;"
              :tableRowClassName="tableRowClassName"
              @row-click="handleRowClick"
              @command-change="handleCommand"
            >
              <template v-slot:max="scope" >
                <span>
                  <el-tooltip
                    effect="dark"
                    placement="top-start"
                    v-if="scope.row.max"
                  >
                    <template #content> {{scope.row.max?.supplier?.name}}<br /> 最后修改时间：{{scope.row.max?.updateTime}}</template>
                    <i class="iconfont icon-tubiao-30" style="font-size:14px"/>
                  </el-tooltip>
                  {{ maxMinCalc(scope.row, 'max') }}
                </span>
              </template>
              <template v-slot:min="scope" >
                <span>
                  <el-tooltip
                    effect="dark"
                    placement="top-start"
                    v-if="scope.row.min"
                  >
                    <template #content> {{scope.row.max?.supplier?.name}}<br /> 最后修改时间：{{scope.row.min?.updateTime}}</template>
                    <i class="iconfont icon-tubiao-30" style="font-size:14px"/>
                  </el-tooltip>
                  {{ maxMinCalc(scope.row, 'min') }}
                </span>
              </template>
              <template v-slot:operation-action="scope">
                <CommandRender
                  :scopeRow='scope.row'
                  :codeList="btnList"
                  :permissionName="permissionName"
                  @command-change="handleCommand"
                />
              </template>
            </TableList>
            <el-pagination
              class="mt-20"
              v-show="total > 0"
              :total="total"
              v-model:currentPage="listQuery.page"
              :page-size="listQuery.size"
              :page-sizes="pageSizes"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              layout="total, sizes, prev, pager, next"
            />
          </template>
        </grid-item>
      </grid-layout>
    </div>
    <FormComponent
      v-if="dialogFormVisible"
      :id="activeId"
      :initFormData="initFormData"
      :fromFieldData="fromFieldData"
      :dialogFormVisible="dialogFormVisible"
      :api="pathApi"
      @update:visibel="() => dialogFormVisible = false"
      @submit="handleSubmit(formData)"
    />
    <FormComponent
      v-if="addPriceVisible"
      :id="0"
      :initFormData="initPriceFormData"
      :fromFieldData="fromPriceFieldData"
      :dialogFormVisible="addPriceVisible"
      api="materialInquiry"
      @update:visibel="addPriceVisible = false"
      @submit="handleSubmit(formData)"
    >
      <template v-slot:front>
        <MateriallDescription :detail="activeRow"/>
      </template>
    </FormComponent>
    <el-dialog
      v-model="deliverVisible"
      title="出库"
      width="70%"
    >
      <el-form
        ref="dataForm"
        :model="ruleForm"
        :rules="rules"
        label-position="top"
        label-width="100px"
        class="mb-20"
      >
        <div class="underlineForm">
          <el-form-item label="数量" prop="num">
            <el-input v-model="ruleForm.num" type="number" :min="0" ></el-input>
          </el-form-item>
          <el-form-item label="位置" prop="locationId">
            <el-tree-select :filterable="true" :data="locationOption" :render-after-expand="false" v-model="ruleForm.locationId" placeholder="输入关键字搜索" check-strictly node-key="id" :props="{ children: 'children', label: 'name' }" :clearable="true" />
            <!-- <el-select :filterable="true" v-model="ruleForm.locationId" class="filter-item" placeholder="输入关键字搜索" clearable :size="t('table.btnSize')" @focus="getLocationOption(row)">
              <el-option
                v-for="item in locationOption"
                :key="item.locationId"
                :label="item.location?.location"
                :value="item.locationId"
              />
            </el-select> -->
          </el-form-item>
        </div>
        <div class="dialog-footer mt-20 " >
          <el-button @click="deliverVisible = false" >
            {{ t("table.cancel") }}
          </el-button>
          <el-button
            type="primary"
            @click="handleReturn"
          >
            {{ t("table.confirm") }}
          </el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script lang='ts'>
import { defineComponent, reactive, toRefs, onMounted, ref, unref } from 'vue'
import { ElMessage, ElMessageBox, ElForm } from 'element-plus'
import { cloneDeep } from 'lodash'
import { getDetailById, deleteById, getPageList, putUrl } from '@/apis/Dictionary'
import { getPageList as getUrlList } from '@/apis/Form'

import { PaymentAccountModel, ArrayRowsItem } from '@/model/Index'

import FormComponent from '@/components/Form/index.vue'
import TableList from '@/components/common/TableList.vue'
import { FromFieldData as priceFromFieldData } from '@/views/purchasManage/purchaseInAdvance/priceInfo/FieldFrom'

import { TableName, permissionName } from '@/utils/enum'
import { FromFieldData } from './FieldFrom'
import { TableField, maxMinCalc } from './FieldTable'
import { useI18n } from 'vue-i18n'
import mixin from '@/mixins'
import { pageVo, pageSizes } from '@/utils/index'
import CommandRender from '@/components/common/CommandRender.vue'
import MateriallDescription from './MateriallDescription.vue'

export default defineComponent({
  name: 'Storage',
  components: {
    FormComponent,
    TableList,
    CommandRender,
    MateriallDescription
  },
  props: {
    excludeIds: { type: Array, required: false, default: () => [] }
  },
  setup() {
    const { t } = useI18n()
    const tableDataRef = ref([])
    const dataForm = ref(ElForm)

    const dataMap = reactive({
      TableName: TableName.TABLE_STORAGE_DELIVERY,
      permissionName: permissionName.STORAGE_DELIVERY,
      initFormData: cloneDeep(FromFieldData),
      fromFieldData: FromFieldData,
      initPriceFormData: cloneDeep(priceFromFieldData),
      fromPriceFieldData: priceFromFieldData,
      columnAllData: TableField,
      pathApi: 'material',
      activeId: 0,
      activeRow: {} as any,
      maxMinCalc,
      list: [],
      materialClassOption: [],
      total: 0,
      listLoading: false,
      listQuery: {
        name: undefined,
        ...pageVo
      },
      dialogFormVisible: false,
      pageSizes,

      tabList: [
        { name: '价格信息', id: 1 }
      ],
      activeTab: 1,
      newHpx: 0,
      btnList: [],
      priceVisible: false,
      addPriceVisible: false,
      userOption: [],
      locationOption: [],
      selectionArray: [],
      deliverVisible: false,
      ruleForm: {
        num: null,
        locationId: null
      },
      rules: {
        num: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        locationId: [{ required: true, message: '请填写必填项', trigger: 'change' }]
      },
      handleCommand(command: string, val?: any) {
        if (command !== 'column') {
          dataMap.activeId = val ? val.id : 0
        }
        switch (command) {
          case 'add':
            dataMap.handleCreate()
            break
          case 'edit':
            dataMap.handleUpdate(val)
            break
          case 'return':
            dataMap.activeRow = val
            dataMap.deliverVisible = true
            dataMap.ruleForm = {
              num: null,
              locationId: null
            }
            dataMap.getLocationOption()
            break
          case 'comfirm':
            dataMap.activeRow = val
            dataMap.handleDeliver(val)
            break
          case 'delete':
            dataMap.handleDelete(val)
            break
          case 'refresh':
            dataMap.handleFilter()
            break
          case 'column':
            (tableDataRef.value[0] as any).setColumnVisible = true
            break
          case 'current-change':
            dataMap.handleCurrentChange(val)
            break
          case 'size-change':
            dataMap.handleSizeChange(val)
            break
          // case 'selection':
          //   dataMap.selectionArray = val
          //   break
          // case 'batch-comfirm':
          //   if (!dataMap.selectionArray.length) {
          //     return ElMessage.error({
          //       message: '请选择数据！',
          //       duration: 1000
          //     })
          //   }
          //   dataMap.handleDeliver()
          //   break
        }
      },
      handleRowClick(row: any) {
        dataMap.activeId = row.id
      },
      calcHeight() {
        return 'calc(100% - 50px)'
      },
      handleTabClick(item: any) {
        dataMap.activeTab = item.id
      },
      handleResizedEvent(i: any, newH: any, newW: any, newHPx: any) {
        dataMap.newHpx = newHPx
      },
      getList() {
        dataMap.listLoading = true
        getUrlList('storage/materialDeliveryInfoDetailPage', dataMap.listQuery).then((res: any) => {
          dataMap.list = res.data.map((kk: any) => {
            const material = {
              ...kk.material,
              materialId: kk.material.id
            }
            delete material.id
            return {
              ...material,
              ...kk
            }
          }) || []
          dataMap.total = res.total
          dataMap.listLoading = false
          dataMap.activeId = dataMap.list.length ? dataMap.list[0].id : 0
        }).catch(() => {
          dataMap.listLoading = false
        })
      },
      handleReset() {
        dataMap.listQuery = {
          name: undefined,
          ...pageVo
        }
        dataMap.handleFilter()
      },
      handleFilter() {
        dataMap.getList()
      },
      handlePriceCreate() {
        dataMap.initPriceFormData.forEach((k: any) => {
          k.formList.forEach((formList: any) => {
            formList.list.forEach((field: any) => {
              if (field.fieldKey === 'materialId') {
                field.value = dataMap.activeId
              }
            })
          })
        })
        dataMap.fromPriceFieldData = cloneDeep(dataMap.initPriceFormData)
        dataMap.addPriceVisible = true
      },
      handleCreate() {
        dataMap.activeId = 0
        dataMap.fromFieldData = cloneDeep(dataMap.initFormData)
        dataMap.dialogFormVisible = true
      },
      handleUpdate(row: any) {
        dataMap.activeId = row.id
        dataMap.fromFieldData = cloneDeep(dataMap.initFormData)

        getDetailById(dataMap.pathApi, row.id).then((res: any) => {
          dataMap.fromFieldData.forEach((k: any) => {
            if (k.type === 1) {
              k.formList.forEach((field: any) => {
                field.value = res[field.fieldKey]
                if (field.fieldKey === 'images') {
                  field.value = res[field.fieldKey] ? res[field.fieldKey].split(',') : []
                }
              })
            }
          })
          dataMap.dialogFormVisible = true
        })
      },
      handleDelete(row: any) {
        ElMessageBox.confirm(
          '确定要删除选中数据吗？',
          '删除',
          {
            confirmButtonText: t('table.confirm'),
            cancelButtonText: t('table.cancel'),
            type: 'warning',
            cancelButtonClass: 'el-button--danger'
          }
        )
          .then(() => {
            deleteById(dataMap.pathApi, row.id).then(() => {
              dataMap.getList()
              ElMessage({
                message: '删除成功',
                type: 'success',
                duration: 1000
              })
            })
          })
      },
      handleSubmit() {
        dataMap.getList()
      },
      handleCurrentChange(page?: any) {
        dataMap.listQuery.page = page
        dataMap.getList()
      },
      handleSizeChange(size: any) {
        dataMap.listQuery.size = size
        dataMap.handleCurrentChange(1)
      },
      getMaterialClassOption() {
        getPageList('materialClass', { page: 1, size: 999 }).then((res: any) => {
          dataMap.materialClassOption = res.data || []
        })
      },
      getUserOptionRemote() {
        getUrlList('user/dropdown/availableUses').then((res: any) => {
          dataMap.userOption = res || []
        })
      },
      handleReturn() { // 返回材料仓库
        const form = unref(dataForm)
        form.validate(async(valid: any) => {
          if (valid) {
            const params = {
              ...dataMap.ruleForm
            }
            if (!params.num) {
              return ElMessage.error('数量不得为0！')
            }
            putUrl(`storage/returnMaterialDelivery/${dataMap.activeRow.id}`, params).then(() => {
              dataMap.getList()
              dataMap.deliverVisible = false
              ElMessage({
                message: '归还成功',
                type: 'success',
                duration: 1000
              })
            })
          }
        })
      },
      handleDeliver(row: any) { // 确认出库
        ElMessageBox.confirm(
          '确定要出库选中数据吗？',
          '出库',
          {
            confirmButtonText: t('table.confirm'),
            cancelButtonText: t('table.cancel'),
            type: 'warning',
            cancelButtonClass: 'el-button--danger'
          }
        )
          .then(() => {
            putUrl(`storage/confirmMaterialDelivery/${row.id}`).then(() => {
              dataMap.getList()
              ElMessage({
                message: '出库成功',
                type: 'success',
                duration: 1000
              })
            })
          })
      },
      getLocationOption() {
        getUrlList('location/tree').then((res: any) => {
          dataMap.locationOption = res || []
        })
      },
      tableRowClassName({ row }: any) {
        const { statusValue } = row
        if (statusValue === '待确认') {
          return 'row-red'
        }
      }
    })
    const { mixinData } = mixin(dataMap)
    onMounted(() => {
      dataMap.btnList = [
        {
          pkey: `${dataMap.permissionName}_CONFIRM`,
          name: '确认',
          command: 'comfirm',
          visible: (row: any) => {
            return ['待确认'].includes(row.statusValue)
          }
        },
        {
          pkey: `${dataMap.permissionName}_RETURN`,
          name: '归还',
          command: 'return',
          visible: (row: any) => {
            return ['已确认'].includes(row.statusValue)
          }
        }
      ]
      mixinData.initHeight()
      dataMap.getList()
      dataMap.getMaterialClassOption()
    })
    return { t, ...toRefs(dataMap), ...toRefs(mixinData), tableDataRef, dataForm }
  }
})
</script>
<style  lang="scss">

</style>
